import { useEffect, useState } from "preact/hooks";
import fetchProduct from "./fetchProduct";

/**
 *
 * @param {tag|gid} id product id `gid://shopify/Product/12345`
 * @returns [data]
 */
export default function useProduct(id) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;

    fetchProduct(id).then(setData);
  }, [id]);

  return [data];
}
